import React from 'react';
import { Link } from 'react-router-dom';
import { ASSET_IMAGES_PATH, SHOW_BRAND_SIGNATURE } from '../../constants';

interface BrandProps {
    /** When set, the brand is a link (header home affordance). Omit on the landing screen. */
    to?: string;
    /** Show the signature image above the wordmark. Defaults to the site-wide SHOW_BRAND_SIGNATURE.
     *  When false, the signature is omitted and only the wordmark renders. */
    showSignature?: boolean;
}

const NAME = 'Dragan Strukelj';
const WORDMARK = 'whitespace-nowrap text-[0.90rem] font-light uppercase tracking-brand text-tone-900';

// Artist signature (image) + wordmark. The wordmark's natural width drives the block width; the
// signature sits in an aspect-ratio box (absolutely positioned so its 512px intrinsic width can't
// inflate the block) stretched to that same width — so image and wordmark are exactly equal width.
// When `showSignature` is false the signature is omitted and the block collapses to the wordmark.
export const Brand = ({ to, showSignature = SHOW_BRAND_SIGNATURE }: BrandProps) => {
    const brand = (
        <span className="inline-flex flex-col items-stretch gap-1">
            {showSignature && (
                <span className="relative block w-full" style={{ aspectRatio: '512 / 215' }}>
                    <img
                        src={`${ASSET_IMAGES_PATH}/signature7.png`}
                        alt={NAME}
                        className="absolute inset-0 h-full w-full object-contain"
                    />
                </span>
            )}
            <span className={WORDMARK} aria-hidden>
                {NAME}
            </span>
        </span>
    );

    if (to) {
        return (
            <Link to={to} className="inline-block" aria-label={`${NAME} — Home`}>
                {brand}
            </Link>
        );
    }
    return brand;
};
